import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { User } from 'src/app/shared/models/app.models';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SidebarService } from 'src/app/shared/services/sidebar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { SignalRService } from 'src/app/shared/services/signalr.service';
import { MinimizedMeetingService } from 'src/app/core/meetings/services/minimized-meeting.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})


export class HeaderComponent implements OnInit, OnDestroy {

  user : User | null = null;
  isMobileSidebarOpen: boolean = false;
  private sidebarSubscription?: Subscription;

  constructor( 
    private _userService: UserService,
    private notificationService: NotificationService,
    private sidebarService: SidebarService,
    private _router: Router,
    private signalRService: SignalRService,
    private minimizedMeetingService: MinimizedMeetingService
  ) { }
  AppConstants = AppConstants;


  ngOnInit(): void {
    this.user = this._userService.user;
    // Subscribe to sidebar state changes
    this.sidebarSubscription = this.sidebarService.isMobileSidebarOpen$.subscribe(
      isOpen => {
        this.isMobileSidebarOpen = isOpen;
      }
    );
    
    // Start SignalR connection when header initializes (user is authenticated)
    // This ensures users receive meeting notifications even when not on meeting page
    if (this._userService.isUserAuthenticated) {
      this.initializeSignalR();
    }
  }
  
  private async initializeSignalR(): Promise<void> {
    try {
      // Start SignalR connection if not already connected
      if (!this.signalRService.isConnected()) {
        await this.signalRService.startConnection();
        console.log('SignalR connection started in header component');
      }
    } catch (error) {
      console.error('Error starting SignalR connection in header:', error);
    }
  }

  ngOnDestroy(): void {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
  }

  toggleMobileSidebar(): void {
    this.sidebarService.toggleMobileSidebar();
  }

  toggleNotificationDropdown(): void {
    this.notificationService.toggleDropdown(); // This will trigger the dropdown toggle
  }

  async onLogout(): Promise<void> {
    // Stop SignalR connection if active
    if (this.signalRService?.isConnected()) {
      await this.signalRService.stopConnection();
    }
    
    // Clear minimized meetings (toaster)
    this.minimizedMeetingService.clearAllMinimizedMeetings();
    
    // Clear user data and token
    this._userService.logout();
    
    // Navigate to login
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
  }

}

